(function(){
'use strict';
function position(){
 document.querySelectorAll('.anitials-extension-after-personalizer').forEach(wrapper=>{
  const root=wrapper.querySelector('[data-ani-extension]');if(!root)return;
  const form=document.getElementById(root.dataset.formId);
  const holder=form?.querySelector('.product__submit__holder');
  if(holder&&wrapper.nextElementSibling!==holder)holder.parentElement.insertBefore(wrapper,holder);
 });
}
function init(){position();let scheduled=false;new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;position()})}).observe(document.querySelector('main')||document.body,{subtree:true,childList:true});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
const busy=new WeakSet();
async function submitExtension(e,form){
 if(!(form instanceof HTMLFormElement))return;
 const roots=[...document.querySelectorAll('[data-ani-extension]')];
 const scope=form.closest('[data-section-type="product-template"]')||form.closest('.product-single')||form.closest('.product')||document;
 const root=roots.find(x=>scope.contains(x)&&x.getClientRects().length>0&&x.querySelector('[data-extension-enabled]')?.checked)
  ||roots.find(x=>x.dataset.formId===form.id&&x.getClientRects().length>0&&x.querySelector('[data-extension-enabled]')?.checked);
 if(!root)return;
 e.preventDefault();e.stopImmediatePropagation();
 if(busy.has(form))return;
 const err=root.querySelector('[data-extension-error]');
 err.hidden=true;
 if(!form.reportValidity()){return}
 const fd=new FormData(form);
 const id=Number(fd.get('id')),quantity=Math.max(1,parseInt(fd.get('quantity')||'1',10));
 if(!id){err.textContent='Selecciona las opciones del collar antes de añadirlo.';err.hidden=false;return}
 const properties={};
 for(const [k,v] of fd.entries()){const m=/^properties\[(.+)\]$/.exec(k);if(m&&typeof v==='string'&&v.trim())properties[m[1]]=v}
 // Respect Personalizer required fields where they are represented by required inputs.
 const missing=[...document.querySelectorAll('[required]')].find(el=>form.contains(el)&&!el.checkValidity());
 if(missing){missing.reportValidity();return}

 // Never bypass the required LETRA selection when adding the collar and alargo together.
 // Product Personalizer renders its choice separately from the native variant selector.
 function selectedLetter(){
   const norm=t=>String(t||'').trim().toUpperCase();
   const isLetter=t=>/^[A-ZÑ]$/.test(norm(t));
   const matching=Object.entries(properties).filter(([k])=>/\b(letra|inicial|letter)\b/i.test(k));
   if(matching.some(([,v])=>isLetter(v)))return true;
   const host=form.closest('.product-single')||form.closest('product-info')||document;
   const fields=[...host.querySelectorAll('input,select')].filter(el=>/\b(letra|inicial|letter)\b/i.test([el.name,el.id,el.getAttribute('aria-label'),el.dataset?.name].join(' ')));
   if(fields.some(el=>isLetter(el.value)&&(!['radio','checkbox'].includes(el.type)||el.checked)))return true;
   const selected=[...host.querySelectorAll('.selected,.is-selected,.active,[aria-checked="true"],[aria-selected="true"],[aria-pressed="true"],input:checked')];
   return selected.some(el=>{
     const labels=[el.value,el.getAttribute('data-value'),el.getAttribute('aria-label'),el.getAttribute('title'),el.textContent,el.querySelector('img')?.alt];
     if(!labels.some(isLetter))return false;
     const context=[el.closest('[class*="pplr"]')?.textContent?.slice(0,800),el.closest('[class*="personaliz"]')?.textContent?.slice(0,800),el.closest('[data-option-name]')?.getAttribute('data-option-name')].join(' ');
     return /LETRA|INICIAL|LETTER/i.test(context);
   });
 }
 if(!selectedLetter()){
   err.textContent='Selecciona primero la letra de tu collar para añadirlo al carrito.';
   err.hidden=false;
   root.closest('.product__block')?.scrollIntoView({behavior:'smooth',block:'center'});
   return;
 }
 const key='alargo-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,8);
 properties['_Referencia alargo']=key;
 const addon={id:Number(root.dataset.extensionId),quantity,properties:{'_Referencia alargo':key}};
 const button=form.querySelector('[data-add-to-cart]');
 busy.add(form);if(button)button.disabled=true;
 try{
 const route=window.Shopify?.routes?.root||'/';
 const response=await fetch(route+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity,properties},addon]})});
 if(!response.ok){const detail=await response.json().catch(()=>({}));throw Error(detail.description||'No se pudo añadir el alargo.')}
 document.dispatchEvent(new CustomEvent('theme:cart:refresh',{bubbles:true}));
 }catch(error){err.textContent=error.message;err.hidden=false}
 finally{busy.delete(form);if(button)button.disabled=false}
}
document.addEventListener('click',e=>{const button=e.target.closest('[data-add-to-cart]');if(button){const form=button.form||button.closest('form');if(form)submitExtension(e,form)}},true);
document.addEventListener('submit',e=>submitExtension(e,e.target),true);
})();